


































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State, Getter, Action, Mutation } from 'vuex-class';
import auth from '@/utils/auth';

const namespace = 'user';
@Component({})
export default class Topbar extends Vue {
  @State('orgId', { namespace }) orgId!: string;
  @Mutation('SET_ORGID', { namespace }) setOrgId!: Function;
  @Getter('nickname') nickname: any;
  @Action('quit', { namespace }) Quit: any;
  private async quit() {
    try {
      await this.Quit();
    } catch (err) {
      auth.removeToken();
    } finally {
      this.$message.warning('您已退出登录，请重新登录');
      this.$router.push({ path: '/login' });
      this.setOrgId('');
    }
  }
  /**
   * @description: 退出用户视角-用于耕子端分校视角
   */
  private async quitAdmin() {
    let path: any = window.localStorage.getItem('admin-path'),
      gzToken: any = window.localStorage.getItem('admin-gz-token');
    window.localStorage.removeItem('admin-path');
    window.localStorage.removeItem('admin-gz-token');

    let orgPath: any = window.localStorage.getItem('admin-org-path'),
      orgToken: any = window.localStorage.getItem('admin-org-token');

    window.localStorage.removeItem('admin-org-path');
    window.localStorage.removeItem('admin-org-token');

    if (!orgPath) {
      if (!path) return;
      location.assign(path + `#auto=true&token=${gzToken}`);
    } else {
      window.localStorage.removeItem('admin-org-path');
      window.localStorage.removeItem('admin-org-token');
      this.$router.push({
        path:
          orgPath +
          `#auto=true&level=1&gzToken=${gzToken}&orgToken=${orgToken}&href=${encodeURIComponent(
            path
          )}`
      });
      location.reload()
    }
  }
}
